import React, { useEffect, useMemo, useRef, useState } from 'react'
import MarkdownWrapper from '../utils/markdown-wrapper'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const StoryIntroduction = ({ index, color, story, isMobile = false, inActive = null, onSetActiveSectionNum = null }) => {
    const [isIntersecting, setIsIntersecting] = useState(false)
    const ref = useRef(null)

    const observer = useMemo(() =>
        new IntersectionObserver(([entry]) => setIsIntersecting(entry.isIntersecting), { threshold: 0.5 }
        ), [])

    useEffect(() => {
        observer.observe(ref.current)
        return () => {
            observer.disconnect()
        }
    }, [ref, observer])

    useEffect(() => {
        if (isIntersecting && onSetActiveSectionNum) {
            onSetActiveSectionNum(index)
        }
    }
    , [index, isIntersecting])

    return (
        <div
            key={index}
            // id={`${isMobile ? `section-${index}` : 'introduction'}`}
            id="introduction"
            ref={ref}
            className={`location-introduction ${color}-bg ${inActive ? 'hidden' : ''}`}>
            <div className="location-background" style={{ backgroundImage: `url(${story.locationBackgroundImage?.url})` }} />
            <div className="container">
                <h1>{story.locationName}</h1>
                <div className="location-description">
                    <MarkdownWrapper content={story.locationIntroduction} />
                </div>
            </div>
            {!isMobile &&
                <div className="mouse-icon">
                    {/* NOTE: this may be too much bounce.... */}
                    <FontAwesomeIcon
                        icon="chevron-down"
                        className="fa-bounce"
                        style={{
                            '--fa-bounce-land-scale-x': 0.9,
                            '--fa-bounce-land-scale-y': 0.9
                        }}/>
                </div>
            }
        </div>
    )
}

export default StoryIntroduction
